export default __webpack_public_path__ + "static/media/game_thumbnail.eb53af7a.png";